import React from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
export function PrivateRoute({ children, ...rest }) {
  const { IsAuthenticated, exp } = useSelector((state) => state.auth);
  const currentTime = new Date().getTime();
  const TOKEN = localStorage.getItem("JWT_TOKEN");
  return (
    <Route
      {...rest}
      render={({ location }) =>
        IsAuthenticated === true && currentTime < exp && TOKEN ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
